export const PDF_CONTENT_TYPE = 'application/pdf';

export interface CourseDocument {
  id: string;
  fileName: string;
  url: string | null;
}

export const isPdf = (contentType: string): boolean => contentType === PDF_CONTENT_TYPE;
